import { useEffect } from "react";
import {
  customEvent,
  daangnPixelTrack,
  dableCustomEvent,
  DableEventName,
  kakaoPixel,
  tossPixelPageView,
} from "goi_common";
import { sessionStorage, storageKeys } from "@/utils/storage";

const SCROLL_THRESHOLDS = [10, 25, 50, 75, 95] as const;

const useLandingPageEffect = () => {
  useEffect(() => {
    sessionStorage.set("firstVisitPath", "home");
    sessionStorage.remove(storageKeys.Platform);
    sessionStorage.remove(storageKeys.productGroup);

    tossPixelPageView();
    kakaoPixel()?.pageView();
    daangnPixelTrack("ViewPage");
    dableCustomEvent(DableEventName.PageView);

    const firedThresholds = new Set<number>();

    const handleScroll = () => {
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const scrollHeight =
        document.documentElement.scrollHeight - window.innerHeight;
      if (scrollHeight <= 0) return;

      const scrollPercentage = Math.round((scrollTop / scrollHeight) * 100);

      SCROLL_THRESHOLDS.forEach((threshold) => {
        if (!firedThresholds.has(threshold) && scrollPercentage >= threshold) {
          firedThresholds.add(threshold);
          customEvent({
            newGtm: {
              path: "home",
              trigger_and_target: `scroll_${threshold}`,
            },
          });
        }
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
};

export default useLandingPageEffect;
